import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import { useState } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { LineUserAccountList } from "~/components/common/line_user_accounts/LineUserAccountList";
import { LineUserAccountModal } from "~/components/common/line_user_accounts/LineUserAccountModal";
import type { LineUserAccountsResponse } from "~/models/LineUserAccount";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

type Props = {
	lineUserAccounts: LineUserAccountsResponse;
};

export function Page({ lineUserAccounts }: Props) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<VendorSettingLayout>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: PATH, label: "設定一覧" },
						{ label: "LINE設定" }
					]}
				/>
			</div>
			<Panel>
				<PanelHeader
					rightArea={
						<Button
							onClick={() => {
								setIsModalOpen(true);
							}}
							variant="primary"
						>
							追加
						</Button>
					}
					title="LINEアカウント設定"
				/>
				<PanelBody>
					<LineUserAccountList
						lineUserAccounts={lineUserAccounts.lineUserAccounts}
					/>
					{isModalOpen ? (
						<LineUserAccountModal
							handleClose={() => {
								setIsModalOpen(false);
							}}
						/>
					) : null}
				</PanelBody>
			</Panel>
		</VendorSettingLayout>
	);
}
